"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mockedYandexPaymentProvider = exports.mockedPaypalPaymentProvider = void 0;
const common_interfaces_1 = require("../../common-interfaces");
const legal_entity_1 = require("../legal-entity");
const payment_currency_1 = require("../payment-currency");
exports.mockedPaypalPaymentProvider = {
  id: 1,
  name: 'title',
  type: common_interfaces_1.PaymentProvider.paypal,
  legalEntity: legal_entity_1.mockedLegalEntityResponse,
  notes: 'notes',
  isDeleted: false,
  createdAt: new Date(),
  updatedAt: null,
  currencies: [payment_currency_1.mockedPaymentCurrencyResponse],
  customFields: [],
  oldId: null
};
exports.mockedYandexPaymentProvider = {
  id: 2,
  name: 'title',
  type: common_interfaces_1.PaymentProvider.yandex,
  legalEntity: legal_entity_1.mockedLegalEntityResponse,
  notes: 'notes',
  isDeleted: false,
  createdAt: new Date(),
  updatedAt: null,
  currencies: [payment_currency_1.mockedPaymentCurrencyResponse],
  customFields: [],
  oldId: null
};